import _implicitStylesheets from "./container.css";
import _implicitScopedStylesheets from "./container.scoped.css?scoped=true";
import _analyticsGtmNoScript from "analytics/gtmNoScript";
import _aceConfirm from "ace/confirm";
import _aceHeader from "ace/header";
import _aceAgentforceChat from "ace/agentforceChat";
import _aceFooter from "ace/footer";
import _analyticsHandler from "analytics/handler";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  key: 0
};
const stc1 = {
  key: 1
};
const stc2 = {
  classMap: {
    "page-container": true
  },
  key: 2
};
const stc3 = {
  key: 3
};
const stc4 = {
  key: 4
};
const stc5 = {
  key: 6
};
const stc6 = {
  key: 7
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, ncls: api_normalize_class_name, ddc: api_deprecated_dynamic_component, h: api_element} = $api;
  return [api_custom_element("analytics-gtm-no-script", _analyticsGtmNoScript, stc0), api_custom_element("analytics-handler", _analyticsHandler, stc1, [api_element("div", stc2, [api_custom_element("ace-confirm", _aceConfirm, stc3), api_custom_element("ace-header", _aceHeader, stc4), api_element("div", {
    className: api_normalize_class_name($cmp.rootContainerCss),
    key: 5
  }, [api_deprecated_dynamic_component("x-lazy", $cmp.pageComponent, stc5)]), $cmp.showAgentforceChat ? api_custom_element("ace-agentforce-chat", _aceAgentforceChat, stc6) : null, api_custom_element("ace-footer", _aceFooter, {
    className: api_normalize_class_name($cmp.footerClass),
    key: 8
  })])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5pkbgumkf6d";
tmpl.legacyStylesheetToken = "undefined-_container";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
